/* eslint-disable */
const { Environment, Network, RecordSource, Store } = require('relay-runtime')

const store = new Store(new RecordSource())

export const JUDO_SESSION_KEY = 'judo_session'

export const isRunningInIframe = () => {
    return window !== window.parent
}

const uri = {
    production: 'https://api.rover.io/graphql',
    staging: 'https://api.staging.rover.io/graphql',
    development: 'http://localhost:4000/graphql',
}

export const getJudoTokenFromURL = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const judoToken = urlParams.get('token')

    return judoToken
}

const getToken = () => {
    const session = JSON.parse(localStorage.getItem('ember_simple_auth:session'))

    return session ? session.authenticated.token : null
}

export const saveJudoToken = token => {
    sessionStorage.setItem(JUDO_SESSION_KEY, JSON.stringify({ token }))
}

const getJudoToken = () => {
    const session = JSON.parse(sessionStorage.getItem(JUDO_SESSION_KEY))

    return session ? session.token : getJudoTokenFromURL()
}

const generateHeaders = () => {
    const token = getToken()
    const judoToken = getJudoToken()

    const headers = {
        accept: 'application/json',
        'Content-Type': 'application/json',
    }

    if (judoToken) {
        return {
            ...headers,
            'x-judo-token-key': judoToken,
        }
    } else if (token) {
        return {
            ...headers,
            Authorization: `Bearer ${token}`,
        }
    }

    return headers
}

const network = Network.create(async (operation, variables) => {
    const response = await fetch(uri[process.env.NODE_ENV], {
        method: 'POST',
        headers: generateHeaders(),
        body: JSON.stringify({
            query: operation.text,
            variables,
        }),
    })

    const data = await response.json()

    if (data.hasOwnProperty('errors') && data.errors[0].message.includes('Not Authorised')) {
        if (!isRunningInIframe()) {
            window.location.replace('/auth/sign-in')
        }
        return
    } else {
        return data
    }
})

const environment = new Environment({
    network,
    store,
})

export default environment
